export const PAYROLL_FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'monthly', label: 'Monthly' },
];

export const PAYROLL_DAY_OPTIONS = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
];

export const CARE_LOCATION_TYPE_OPTIONS = [
  { value: 'care_home', label: 'Care Home' },
  { value: 'supported_living', label: 'Supported Living' },
  { value: 'community', label: 'Community' },
  { value: 'other', label: 'Other' },
];
